import React from 'react';
import PropTypes from 'prop-types';
import Mousetrap from 'mousetrap';

import { hasChanged } from '../../utils/react/propsComparisons';

const hasDisableCloseChanged = hasChanged('disableClose');

class ModalKeyboardManager extends React.Component {
    componentDidMount() {
        const { close, disableClose } = this.props;
        if (close && !disableClose) this.bindEscKeyListener();
    }

    componentDidUpdate(prevProps) {
        if (!hasDisableCloseChanged(prevProps, this.props)) return;

        if (this.props.disableClose) {
            this.unbindEscKeyListener();
        } else {
            this.bindEscKeyListener();
        }
    }

    componentWillUnmount() {
        this.unbindEscKeyListener();
    }

    bindEscKeyListener = () => {
        const { close } = this.props;
        if (this.escKeyBound) return;

        Mousetrap.bind('escape', (event) => close());
        this.escKeyBound = true;
    };

    unbindEscKeyListener = () => {
        if (!this.escKeyBound) return;

        Mousetrap.unbind('escape');
        this.escKeyBound = false;
    };

    render() {
        return this.props.children;
    }
}

ModalKeyboardManager.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
    close: PropTypes.func,
    disableClose: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default ModalKeyboardManager;
